/**
 * 請求CSV
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/settings/billing_transactions`

const setting_billing_transaction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions }) {
      const params = {
        billing_monthly: conditions.billing_monthly,
        close_day_type: conditions.close_day_type,
        billing_address_id: conditions.billing_address_id,
        deal_no: conditions.deal_no
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data)
        })
      })
    },
    /**
     * @param commit
     * @param params
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {
  },
}

export default setting_billing_transaction
